export function QuestionCard() {
  const cardItems = document.querySelectorAll(".js-card-item");

  cardItems.forEach(function (cardItem) {
    cardItem.addEventListener("click", function () {
      const question = cardItem.querySelector(".js-card-item-question");
      const answer = cardItem.querySelector(".js-card-item-answer");

      // answerにis-activeクラスがあるかチェック
      if (answer.classList.contains("is-active")) {
        // 閉じる処理
        answer.classList.remove("is-active");
        question.classList.remove("is-hidden");
      } else {
        // 開く処理
        answer.classList.add("is-active");
        question.classList.add("is-hidden");
      }
    });
  });
}
